export const getEventDescription = (item, defaultMessage) => {
  try {
    const payload = JSON.parse(item.payload)
    if (payload.Event) return payload.Event
  } catch (e) { /* ignore parse errors */ }
  return defaultMessage
}



// WEBPACK FOOTER //
// ./src/helpers/eventDescription.js